import { createAsyncThunk } from '@reduxjs/toolkit'
import {  QUERY_POST_SET_WORKSHOP_APPOINTMENT, QUERY_PUT_BLOCKCASE, QUERY_PUT_UPDATE_CLICKTOCALL, QUERY_POST_SET_DOCUMENTATION,
  QUERY_POST_SET_CLAIMS, QUERY_POST_FACTORY_COMMENT, QUERY_POST_ADVANCE_FACTORY_CASE,
  QUERY_POST_SET_TERMINATIONS, QUERY_POST_SET_SUBSTITUTION, QUERY_POST_SET_DELIVERY, QUERY_POST_SET_OVC, QUERY_POST_SET_ITV, QUERY_POST_SET_FUELCARD,
  QUERY_POST_SET_MARSH, QUERY_POST_SET_LETTER,QUERY_POST_SET_LETTER_QUERY, QUERY_POST_TEMPLATE_DRAFT, QUERY_POST_SET_WORKSHOP_APPOINTMENT_DRAFT,
  QUERY_GET_FACTORY_ADVANCE_OPTIONS} from '../../fetch/constantQueries'
import { fetchPut} from '../../fetch/fetchConfig'
import { baseThunk, getUrl } from '../../fetch/basicThunk'


export const blockCase = createAsyncThunk(
    'currentCase/blockCase',
    async (caseId, thunkApi) => {
          const response = await fetch( getUrl() + QUERY_PUT_BLOCKCASE + `?caseId=${caseId}&block=true`, fetchPut());
          if (!response.ok){
            throw response.status};
          const data = response.json()
    return data
    }
  )
  
  export const unBlockCase = createAsyncThunk(
    'currentCase/unBlockCase',
    async (caseId, thunkApi) => {
          const response = await fetch( getUrl() + QUERY_PUT_BLOCKCASE + `?caseId=${caseId}&block=false`, fetchPut());
          if (!response.ok){
            throw response.status};
          const data = response.json()
    return data
    }
  )

  export const updateClickToCall = baseThunk("cases/updateClickToCall",QUERY_PUT_UPDATE_CLICKTOCALL,"PUT");

  export const setWorkshopAppointment = baseThunk("cases/setWorkshopAppointment", QUERY_POST_SET_WORKSHOP_APPOINTMENT, "POST")

  export const setDocumentation = baseThunk("cases/setDocumentation", QUERY_POST_SET_DOCUMENTATION, "POST")

  export const setClaims = baseThunk("cases/setClaims", QUERY_POST_SET_CLAIMS, "POST")

  export const sendFactoryComment = baseThunk('currentCase/sendFactoryComment', QUERY_POST_FACTORY_COMMENT, "POST")

  export const advanceFactoryCase = baseThunk("currentCase/advanceFactoryCase", QUERY_POST_ADVANCE_FACTORY_CASE, "POST")

  export const setTerminations = baseThunk("cases/setTerminations", QUERY_POST_SET_TERMINATIONS, "POST")

  export const setSubstitutionVehicle = baseThunk("cases/setSubstitution", QUERY_POST_SET_SUBSTITUTION, "POST")

  export const setDelivery = baseThunk("cases/setDelivery", QUERY_POST_SET_DELIVERY, "POST")

  export const setOvc = baseThunk("cases/setOvc", QUERY_POST_SET_OVC, "POST")

  export const setItv = baseThunk("cases/setItv", QUERY_POST_SET_ITV, "POST")

  export const setFuelCard = baseThunk("cases/setFuelCard", QUERY_POST_SET_FUELCARD, "POST")

  export const setMarsh = baseThunk("cases/setMarsh", QUERY_POST_SET_MARSH, "POST")

  export const setLetter = baseThunk("cases/setLetters", QUERY_POST_SET_LETTER, "POST")

  export const setLetterQuery = baseThunk("cases/setLetterQuery", QUERY_POST_SET_LETTER_QUERY, "POST")

